import { MdOutlineVoicemail } from "react-icons/md";

import { CALL_STATUS } from "@/constants/call";
import { CallStatus } from "@/types/call.types";

import { DialButton } from "./dial-button";

type DialpadProps = {
    onNumberClick: (num: string) => void;
    callStatus: CallStatus;
};

const getDialPad = (callStatus: CallStatus) => {
    const isActive =
        callStatus === CALL_STATUS.CONNECTED ||
        callStatus === CALL_STATUS.CONNECTING ||
        callStatus === CALL_STATUS.RINGING;

    return [
        { num: "1", letters: <MdOutlineVoicemail size={16} className="text-gray-500" /> },
        { num: "2", letters: "ABC" },
        { num: "3", letters: "DEF" },
        { num: "4", letters: "GHI" },
        { num: "5", letters: "JKL" },
        { num: "6", letters: "MNO" },
        { num: "7", letters: "PQRS" },
        { num: "8", letters: "TUV" },
        { num: "9", letters: "WXYZ" },
        { num: isActive ? "*" : "+", letters: "" },
        { num: "0", letters: "" },
        { num: isActive ? "#" : "<", letters: "" },
    ];
};

export const Dialpad = ({ onNumberClick, callStatus }: DialpadProps) => {
    const dialPad = getDialPad(callStatus);

    return (
        <div className="grid grid-cols-3 gap-2 w-full">
            {dialPad.map(({ num, letters }) => (
                <div className="flex justify-center" key={num}>
                    <DialButton value={num} onClick={onNumberClick} letters={letters as string} />
                </div>
            ))}
        </div>
    );
};
